module.exports = __webpack_public_path__ + "static/media/default-user-pic.561af138.png";